import { h, Component } from 'preact';
import styles from './checkbox_field_style';
import classNames from 'classnames';


export default class CheckboxField extends Component {
  updateValue = (e) => {
    this.props.updateValue(e.target.value);
  } 
  render({field, isValid},{}) {
		var classes = classNames({
      'form-control': true,
      'is-invalid': !isValid
    });
		return (
      <input id={field.mapping} name={field.mapping} type="checkbox" value={field.label} class={classes} onBlur={this.updateValue} />
		);
	}
}



// WEBPACK FOOTER //
// ./field_types/checkbox_field.js